export const selectAttendancePolicies = (state) =>
  state.attendancePolicy?.policies || [];

export const selectAttendancePolicyLoading = (state) =>
  state.attendancePolicy?.loading || false;

export const selectAttendancePolicyError = (state) =>
  state.attendancePolicy?.error || null;

export const selectSelectedAttendancePolicy = (state) =>
  state.attendancePolicy?.selectedPolicy || null;

export const selectAttendancePolicyPagination = (state) =>
  state.attendancePolicy?.pagination || {};
